import { stateStrategy, translateStateStrategy } from '@/features/establishmentLeadsFunnel/constants/stateStrategy.constant';
import { EstablishmentLeadData } from '@/features/establishmentLeadsFunnel/types/establishmentLead.type';

export class EstablishmentLeadsTransformer {
  static quickSearchModelTransformer() {
    return (clients: EstablishmentLeadData[]) => {
      return clients.map((client) => ({
        route: `/establishment-leads/${client.id}/edit`,
        items: [
        ['Nome da empresa', client.display_name],
        ['Etapa', translateStateStrategy[stateStrategy[client.state]]],
        ['Descrição', client.last_state_change_log?.message],
        ]
      }));
    };
  }
}
